import { HiArrowNarrowRight } from "react-icons/hi";

export const actionButtonProps = {
  size: "lg",
  w: "full",
  rightIcon: <HiArrowNarrowRight />,
  "data-testid": "pricing-card-action-button",
};
